import React from "react";
import { BadgeCheck, GraduationCap, Clock, RefreshCw } from "lucide-react";
import { WHY } from "../mock";

const ICONS = { BadgeCheck, GraduationCap, Clock, RefreshCw };

const WhyUs = () => {
  return (
    <section id="why" className="py-20 md:py-28 px-5 md:px-8 bg-[#E7EDF3]">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-center">
        {/* Image with stat */}
        <div className="relative fade-up">
          <div className="rounded-[28px] overflow-hidden shadow-[0_24px_60px_rgba(0,0,0,0.15)]">
            <img
              src={WHY.image}
              alt="Caregiver with patient"
              className="w-full h-[440px] object-cover"
            />
          </div>
          <div className="absolute -bottom-6 -right-2 md:right-8 bg-[#159A90] text-white rounded-[22px] px-7 py-5 shadow-[0_16px_40px_rgba(21,154,144,0.4)] max-w-[230px]">
            <p className="font-heading font-extrabold text-[38px] leading-none">
              {WHY.statValue}
            </p>
            <p className="text-[13px] mt-1 text-white/90 leading-snug">
              {WHY.statLabel}
            </p>
          </div>
        </div>

        {/* Content */}
        <div>
          <div className="fade-up">
            <div className="flex items-center gap-2 mb-4">
              <span className="h-px w-6 bg-[#159A90]" />
              <span className="text-[12px] font-bold tracking-[0.16em] text-[#159A90] uppercase">
                Why Healthsqur
              </span>
            </div>
            <h2 className="font-heading font-extrabold text-[#1B2A4A] text-[30px] md:text-[40px] leading-tight">
              Care that families across India trust with their loved ones
            </h2>
            <p className="text-[#57616e] mt-4 text-[16px] leading-relaxed">
              We built Healthsqur around one belief — that home care should feel like
              a mother caring for her newborn. Watchful, gentle, tireless, always
              there.
            </p>
          </div>

          <div className="grid sm:grid-cols-2 gap-5 mt-9">
            {WHY.features.map((f, i) => {
              const Icon = ICONS[f.icon];
              return (
                <div
                  key={f.title}
                  className="bg-white rounded-2xl p-5 border border-[#DEE6EE] hover:shadow-[0_14px_35px_rgba(0,0,0,0.08)] transition-shadow fade-up"
                  style={{ transitionDelay: `${(i % 2) * 80}ms` }}
                >
                  <span className="flex items-center justify-center w-11 h-11 rounded-xl bg-[#E7EDF3] mb-3">
                    <Icon size={20} className="text-[#159A90]" />
                  </span>
                  <h3 className="font-heading font-bold text-[16px] text-[#1B2A4A]">
                    {f.title}
                  </h3>
                  <p className="text-[13.5px] text-[#6b7481] mt-1.5 leading-relaxed">
                    {f.desc}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default WhyUs;
